import React from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesBanner from './components/FeaturesBanner';
import MobileFeaturesSection from './components/MobileFeaturesSection';
import AiFeaturesSection from './components/AiFeaturesSection';
import PricingSection from './components/PricingSection';
import GamificationSection from './components/GamificationSection';
import ContactUsSection from './components/ContactUsSection';
import FooterSection from './components/FooterSection';

// Note: Ensure the layout around this component does not override its styles.
const LandingPage = () => {
  document.title = "Bem-vindo ao NeoApp | O Sistema Definitivo para sua Academia";
  
  return (
    <React.Fragment>
      {/* Oculta qualquer header ou sidebar externo caso fiquem visíveis acidentalmente */}
      <div className="landing-page-container" style={{ margin: 0, padding: 0, overflowX: 'hidden' }}>
        <Header />
        <HeroSection />
        <FeaturesBanner />
        <MobileFeaturesSection />
        <AiFeaturesSection />
        <PricingSection />
        <GamificationSection />
        <ContactUsSection />
        <FooterSection />
      </div>
    </React.Fragment>
  );
};

export default LandingPage;
